import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-pill-button",
  templateUrl: "./pill-button.component.html",
  styleUrls: ["./pill-button.component.scss"],
})
export class PillButtonComponent {
  @Input() variant: "primary" | "secondary";
  @Input() width: string = "";
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() type: "button" | "submit" | "reset" = "button";

  @Output() clicked = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }

  get buttonClasses(): string {
    return `pill-button pill-button__${this.variant}${
      this.loading ? ' pill-button--loading' : ''
    }`;
  }

  get buttonStyles(): any {
    return this.width ? { width: this.width } : {};
  }
}
